export const QUIT_DASHBOARD_ID = 'quit_smoking';

/** Tiles under the Quit Smoking hero. Ids are seededId(u, 'tile', 'quit_smoking', type), inserted ifAbsent. */
export const QUIT_DASHBOARD_TILES = [
  { type: 'quit.money-saved', size: 'small' },
  { type: 'quit.streak', size: 'small' },
] as const;

/** Where the module mounts (v0.1c modulePath('quit_smoking')). Screens link with absolute paths. */
export const QUIT_BASE = '/m/quit_smoking';
